<template>
  <button
    type="button"
    class="direct-excel-upload-entry"
    :class="{ 'direct-excel-upload-entry--compact': compact }"
    @click="$emit('select')"
  >
    <i class="el-icon-upload2" aria-hidden="true" />
    <span class="direct-excel-upload-entry__body">
      <span class="direct-excel-upload-entry__title">已有打标表？直接上传</span>
      <span v-if="!compact" class="direct-excel-upload-entry__hint">
        跳过选资源，先选更新模式再上传 Excel
      </span>
    </span>
  </button>
</template>

<script>
/**
 * 批量打标「已有打标表」入口：默认 footer 紧凑一行；compact 时与「下一步」同排。
 */
export default {
  name: 'DirectExcelUploadEntry',
  props: {
    /** footer 单行：隐藏副文案、缩小内边距，避免与主按钮上下堆叠 */
    compact: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.direct-excel-upload-entry {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  flex-shrink: 0;
  margin: 0;
  padding: 12px 16px;
  border: 1px dashed var(--link-line-strong, #e5dfd6);
  border-radius: 12px;
  background: var(--link-surface-muted, #f7f4ef);
  color: var(--link-ink-emphasis);
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.direct-excel-upload-entry--compact {
  width: auto;
  max-width: min(420px, 100%);
  padding: 6px 12px;
  border-radius: 999px;
}

.direct-excel-upload-entry:hover {
  border-color: var(--link-ink-faint);
  border-style: solid;
  background: var(--link-surface-head, #f3f0ea);
  box-shadow: 0 2px 8px rgba(28, 25, 23, 0.04);
}

.direct-excel-upload-entry i {
  flex-shrink: 0;
  font-size: var(--link-icon-md);
  color: var(--link-ink-muted);
}

.direct-excel-upload-entry--compact i {
  font-size: var(--link-icon-sm, 14px);
}

.direct-excel-upload-entry__body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.direct-excel-upload-entry--compact .direct-excel-upload-entry__body {
  flex-direction: row;
  align-items: center;
}

.direct-excel-upload-entry__title {
  display: block;
  font-size: var(--link-text-md);
  font-weight: var(--link-font-semibold);
  color: var(--link-ink);
  white-space: nowrap;
}

.direct-excel-upload-entry--compact .direct-excel-upload-entry__title {
  font-size: var(--link-text-sm);
  font-weight: var(--link-font-medium);
}

.direct-excel-upload-entry__hint {
  display: block;
  font-size: var(--link-text-xs);
  font-weight: var(--link-font-regular);
  color: var(--link-ink-muted);
}
</style>
